import { loadDismissablePrompts } from '@ms/yammer-data/dist/domains/dismissablePrompts/actions';
import type { DismissablePromptKey, DismissablePromptType } from '@ms/yammer-data/dist/state/types';
import { isEventsPage } from '@ms/yammer-web-support/dist/location';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type UseLoadDismissablePrompts = ({
  promptKeys,
  promptTypes,
}: {
  readonly promptKeys?: DismissablePromptKey[];
  readonly promptTypes?: DismissablePromptType[];
}) => void;
export const useLoadDismissablePrompts: UseLoadDismissablePrompts = ({ promptKeys = [], promptTypes = [] }) => {
  const dispatch = useDispatch();
  const isLiveEventPage = isEventsPage(window.location.pathname);

  useEffect(() => {
    if (isLiveEventPage) {
      return;
    }

    dispatch(loadDismissablePrompts({ promptKeys, promptTypes }));

    // oxlint-disable-next-line react/exhaustive-deps
  }, [dispatch, ...promptKeys, ...promptTypes, isLiveEventPage]);
};
